<template>
  <error :headline="headline">
    <template slot="image">
      <img class="baseball" alt="baseball" src="../../assets/images/20a-lrn-spt-cat-3-icon-def.svg"/>
    </template>
    <template slot="message">
      <p>The page was not found</p>
    </template>
  </error>
</template>

<script>
  import Error from '@/component/Error';

  export default {
    name: 'PageNotFound',

    components: {
      Error,
    },

    data: function () {
      return {
        headline: 'Swing and a miss!',
      }
    },

    mounted: function () {
      this.interval = setTimeout(() => {
        this.$router.push({name: 'home'});
      }, 15000)
    },

    beforeRouteLeave (to, from, next) {
      clearInterval(this.interval);
      next();
    }
  };
</script>
